<template>
<div class='vx-col w-full mt-2'>
    <section class="modulos-tipos-evaluacion" v-if="unidadOk && tipoOk && (tipos.tp1 || tipos.tp2 ||tipos.tp3 ||tipos.tp4 ||  tipos.tp5 || tipos.tp7 || tipos.tp8 ) ">
        <SimpleVue :datosEvaluacion="datosEvaluacion" :tipos="tipos" :editOk="editOk" :cabecera="cabecera" @change_pregunta_editada="change_pregunta_editada" />
    </section>
    <section class="modulos-tipos-evaluacion" v-if="unidadOk && tipoOk && tipos.tp3 ">
        <!-- <SimpleVue :cabecera="cabecera" @change_pregunta_editada="change_pregunta_editada" :datosEvaluacion="datosEvaluacion" :editOk="editOk" /> -->
    </section>
    <!-- <section class="modulos-tipos-evaluacion" v-if="unidadOk && tipoOk && tipos.tp7 ">
            PRGUNTA ABIERTA
            <Abierta :cabecera="cabecera" :datosEvaluacion="datosEvaluacion" @change_pregunta_editada="change_pregunta_editada" :editOk="editOk"/>
        </section> -->
</div>
</template>

<script>
import SimpleVue from './simple.vue';
import GeneralMixin from "@/mixins/GeneralMixin.js";
export default {
    mixins: [GeneralMixin],
    components: {
        SimpleVue,
    },
    props: {
        editar: {
            type: Object,
            default: () => {}
        },
        editOk: {
            type: Boolean
        },
        libroSelect: {
            type: Object,
            default: () => {}
        },
        unidadSelect: {
            type: Object,
            default: () => {}
        },
        tipoSelect: {
            type: Object,
            default: () => {}
        },
        cabecera: {
            type: Object,
            default: () => {}
        },
        tipos: {
            type: Object,
            default: () => {}
        },
        unidadOk: {
            type: Boolean,
            default: false
        },
        tipoOk: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            arregloUnidades: [],
            propiedades: {},
            datos: {
                pregunta: '',
                opcion: '',
                resp: false,
                puntaje: 1,
                estado: 1,
            },
            datosEvaluacion: '',
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.f_inicio();
    },
    methods: {
        change_pregunta_editada(e) {
            // let me = this
            this.$emit('change_pregunta_editada', e);
            // console.log(' crear pregunta.vue - 84')
        },
        f_inicio() {
            let me = this;
            me.usuario = JSON.parse(localStorage.getItem('usuario'))
            if (this.editOk) {
                // console.log('editando... ', me.editar)
                me.propiedades = {
                    color_boton: 'warning',
                    txt_boton: 'Editar pregunta',
                }
                me.datos = {
                    puntaje: this.editar.puntaje,
                    estado: this.editar.estado
                }
                me.datosEvaluacion = {
                    id: this.editar.idpregunta,
                    pregunta: this.editar.pregunta,
                    puntaje: this.editar.puntaje,
                    estado: this.editar.estado,
                    url: this.editar.url,
                    archivo: this.editar.archivo,
                    columna1: this.editar.columna1,
                    columna2: this.editar.columna2,
                    uso_evaluacion: this.editar.uso_evaluacion,
                    uso_repaso: this.editar.uso_repaso,
                }
            } else {
                me.datos.puntaje = '1';
                me.propiedades = {
                    color_boton: 'success',
                    txt_boton: 'Agregar',
                }
            }
        },
    }
};
</script>
